// src/pages/TermsOfService.jsx
import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsOfService = () => {
  return (
    <>
      <Helmet>
        <title>Terms of Service | Ziyarat Guide</title>
        <meta
          name="description"
          content="Review the terms and conditions for using Ziyarat Guide. Learn about our policies, limitations, and user responsibilities when accessing our website."
        />
        <meta property="og:title" content="Terms of Service | Ziyarat Guide" />
        <meta
          property="og:description"
          content="Understand the rules and terms of using Ziyarat Guide, including usage rights, disclaimers, and intellectual property guidelines."
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>

      <div className="page-container">
        <h1 className="page-title">Terms of Service</h1>

        <p>
          Welcome to Ziyarat Guide. By accessing or using our website, you agree to comply with and be
          bound by the following terms and conditions. Please read them carefully.
        </p>

        <h2>1. Use of Website</h2>
        <ul>
          <li>You may use the website for personal, non-commercial purposes only.</li>
          <li>You must not use the website for any illegal or unauthorized purpose.</li>
          <li>
            You are responsible for ensuring that your use of the website complies with all applicable
            laws and regulations.
          </li>
        </ul>

        <h2>2. Intellectual Property</h2>
        <ul>
          <li>
            All content, images, text, graphics, logos, and videos on this website are the property of
            Ziyarat Guide or its content providers and are protected by copyright and intellectual property
            laws.
          </li>
          <li>
            You may not reproduce, distribute, modify, or use any content from this website for commercial
            purposes without prior written consent.
          </li>
        </ul>

        <h2>3. User Contributions</h2>
        <p>
          Any messages, comments, or feedback submitted through forms on this website are your
          responsibility. By submitting content, you grant Ziyarat Guide a non-exclusive, worldwide,
          royalty-free license to use, reproduce, and display it.
        </p>

        <h2>4. Disclaimers</h2>
        <p>
          The information provided on Ziyarat Guide is for general informational purposes only. While we
          strive to keep content accurate and up to date, we make no warranties or guarantees regarding the
          completeness, accuracy, reliability, or availability of any information on the website.
        </p>

        <h2>5. Limitation of Liability</h2>
        <p>
          Ziyarat Guide shall not be liable for any direct, indirect, incidental, special, or consequential
          damages resulting from your use of the website, including any loss of data or content.
        </p>

        <h2>6. External Links</h2>
        <p>
          The website may contain links to third-party websites. We do not control, endorse, or assume
          responsibility for the content, privacy policies, or practices of these external sites.
        </p>

        <h2>7. Changes to Terms</h2>
        <p>
          We may update these Terms of Service at any time. Changes will be posted on this page, and your
          continued use of the website constitutes acceptance of the updated terms.
        </p>

        <h2>8. Governing Law</h2>
        <p>
          These Terms of Service are governed by and construed in accordance with the laws of the
          jurisdiction in which Ziyarat Guide operates.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          If you have any questions about these Terms of Service, please contact us at{" "}
          <a href="mailto:info@ziyaratguide.com">info@ziyaratguide.com</a>.
        </p>
      </div>
    </>
  );
};

export default TermsOfService;
